import { InjectionKey } from 'vue';
import Moralis from 'moralis/types';

export const MoralisKey: InjectionKey<Moralis> = Symbol('Moralis');
